import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box, TextField, Typography, Button, Snackbar, Alert, Grid,
  FormControl, FormLabel, RadioGroup, FormControlLabel, Radio,
  Select, MenuItem, InputLabel, FormGroup, Checkbox, Switch
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import axios from 'axios';

const SimpleForm = ({ sx, handleClose, onPackageSelect }) => {
  const [total, setTotal] = useState(100); // Default to Basic package total
  const [nonShooters, setNonShooters] = useState(0);
  const [includeNonShooters, setIncludeNonShooters] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [date, setDate] = useState('');
  const [timeFrame, setTimeFrame] = useState('');
  const [packageType, setPackageType] = useState('Basic');
  const [showSuccessNotification, setShowSuccessNotification] = useState(false);
  const [loading, setLoading] = useState(false);
  const [processURL, setProcessURL] = useState('');
  const [selectedGauges, setSelectedGauges] = useState([]);
  const [licenceNumber, setLicenceNumber] = useState('');

  useEffect(() => {
    if (processURL) {
      window.open(processURL, '_blank');
    }
  }, [processURL]);

  useEffect(() => {
    calculateTotal();
  }, [packageType, nonShooters, includeNonShooters]);

  

  const handlePackageChange = (event) => {
    const newPackageType = event.target.value;
    setPackageType(newPackageType);
    onPackageSelect(newPackageType); // Lift state up
    
    // existing logic...
  };

  const handleIncludeNonShootersChange = (event) => {
    setIncludeNonShooters(event.target.checked);
  };

  const handleNonShootersChange = (event) => {
    setNonShooters(Number(event.target.value));
  };

  const calculateTotal = () => {
    const basePrices = {
      'Basic': 75,
      'Standard': 85,
      'Premium': 165
    };
    let newTotal = basePrices[packageType] || 100;
    if (includeNonShooters) {
      newTotal += 35 * nonShooters;
    }
    setTotal(newTotal);
  };

  const handleSubmit = () => {
    setLoading(true);
    axios.post('https://us-central1-menu-diario-e832a.cloudfunctions.net/createPlaceToPaySessionTextMessage', 
    {
      name: 'Angel Vazquez',
      date,
      timeFrame,
      packageType,
      total: Number(total),
      phoneNumber
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      setProcessURL(response.data.processUrl);
      setShowSuccessNotification(true);
    }).catch((error) => {
      console.error('Error:', error);
    }).finally(() => {
      setLoading(false);
    });
  };

  return (
    <Box sx={{ ...sx }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Make Reservation
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            label="First name"
            type="text"
            fullWidth
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            sx={{ mb: 2 }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Last name"
            type="text"
            fullWidth
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            sx={{ mb: 2 }}
          />
        </Grid>
      </Grid>
      <TextField
        label="Phone Number"
        type="tel"
        fullWidth
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        sx={{ mb: 2 }}
      />
      <TextField
        label="Gun licence #"
        type="text"
        fullWidth
        value={licenceNumber} // This should probably be a separate state
        onChange={(e) => setLicenceNumber(e.target.value)}
        sx={{ mb: 2 }}
      />
      <TextField
        label="Reservation date"
        type="date"
        fullWidth
        value={date}
        onChange={(e) => setDate(e.target.value)}
        sx={{ mb: 2 }}
      />
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Time Frame</InputLabel>
        <Select
          value={timeFrame}
          label="Time Frame"
          onChange={(e) => setTimeFrame(e.target.value)}
        >
          <MenuItem value="9am-11am">9 AM - 11 AM</MenuItem>
          <MenuItem value="12pm-2pm">12 PM - 2 PM</MenuItem>
          <MenuItem value="3pm-5pm">3 PM - 5 PM</MenuItem>
        </Select>
      </FormControl>
      <FormControl component="fieldset" sx={{ mb: 2 }}>
        <FormLabel component="legend">Package Type</FormLabel>
        <RadioGroup
          row
          value={packageType}
          onChange={handlePackageChange}
        >
          <FormControlLabel value="Basic" control={<Radio />} label="Basic" />
          <FormControlLabel value="Standard" control={<Radio />} label="Regular" />
          <FormControlLabel value="Premium" control={<Radio />} label="Premium" />
        </RadioGroup>
      </FormControl>
      <FormGroup row sx={{ alignItems: 'center', mb: 2 }}>
        <FormControlLabel
          control={<Switch checked={includeNonShooters} onChange={handleIncludeNonShootersChange} />}
          label="Include Non-Shooters"
        />
        {includeNonShooters && (
          <TextField
            type="number"
            label="Number of Non-Shooters"
            value={nonShooters}
            onChange={handleNonShootersChange}
            sx={{ width: '150px', ml: 2 }}
          />
        )}
      </FormGroup>
      <TextField
        label="Total"
        type="number"
        fullWidth
        value={total}
        disabled
        sx={{ mb: 2 }}
      />
      <LoadingButton
        onClick={handleSubmit}
        variant="contained"
        loading={loading}
        disabled={loading}
        sx={{ mb: 2 }}
      >
        Submit
      </LoadingButton>
      <Snackbar
        open={showSuccessNotification}
        autoHideDuration={4000}
        // onClose={handleCloseSuccessNotification}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="success">
          Form submitted successfully!
        </Alert>
      </Snackbar>
    </Box>
  );
};

SimpleForm.propTypes = {
  sx: PropTypes.object,
  handleClose: PropTypes.func,
};

export default SimpleForm;
